// TOP LEVEL IMPORTS
import React from 'react';
// COMPONENTS
// ANTD
import Tag from 'antd/lib/tag';
import Button from 'antd/lib/button';
// MODULES
import GeneralHelpers from 'lib/helpers/GeneralHelpers';
import ActionMenu from './ActionMenu';

export const MOBILE_COLUMNS = [
  // {
  //   title: 'ID',
  //   dataIndex: '_id',
  //   key: '_id',
  // },
  {
    title: 'SENT ON',
    dataIndex: 'sentAt',
    key: 'sentAt',
    render: (text, record) => {
      if (record.sentAt) {
        return <span>{GeneralHelpers.formatTableDate(record.sentAt)} </span>;
      }
    },
  },
  {
    title: 'Status',
    dataIndex: 'complete',
    key: 'complete',
    render: (text, record) => {
      if (record.complete) {
        return <Tag color="green">COMPLETE</Tag>;
      }
      return <Tag color="yellow">INCOMPLETE</Tag>;
    },
  },
  {
    title: 'ACTIONS',
    width: 85,
    render: (text, record) => <ActionMenu record={record} />,
  },
];

export const FULL_SCREEN_COLUMNS = [
  // {
  //   title: 'ID',
  //   dataIndex: '_id',
  //   key: '_id',
  // },
  {
    title: 'SENT ON',
    dataIndex: 'sentAt',
    key: 'sentAt',
    render: (text, record) => {
      if (record.sentAt) {
        return <span>{GeneralHelpers.formatTableDate(record.sentAt)} </span>;
      }
    },
  },
  {
    title: 'COMPLETED ON',
    dataIndex: 'completedAt',
    key: 'completedAt',
    render: (text, record) => {
      if (record.completedAt) {
        return <span>{GeneralHelpers.formatTableDate(record.completedAt)} </span>;
      }
    },
  },
  {
    title: 'STATUS',
    dataIndex: 'complete',
    key: 'complete',
    render: (text, record) => {
      if (record.complete) {
        return <Tag color="green">COMPLETE</Tag>;
      }
      return <Tag color="yellow">INCOMPLETE</Tag>;
    },
  },
  // {
  //   title: '',
  //   render: (text, record) => {
  //     if (record.complete) {
  //       return <Button type="primary">VIEW</Button>;
  //     }
  //   },
  // },
  {
    title: 'ACTIONS',
    width: 85,
    render: (text, record) => <ActionMenu record={record} />,
  },
];



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/ClientQuestionnaires/columns.js